import { Component, ViewChild, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';

import PerfectScrollbar from 'perfect-scrollbar';

import { Events } from '@providers/common/events.service';
import { UserProvider } from '@providers/user/user.service';
import { DashboardsService } from '@providers/dashboards/dashboards.service';
import { AppStorageProvider } from '@providers/common/app-storage.service';
import { UtilityFunctionService } from '@providers/common/utilityFunction.service';

import { CapacitorUtilsService } from '@providers/common/capacitorUtils.service';
import { DataService } from '@providers/common/data.service';

import { MenuBaseComponent } from '@components/menu-base/menu-base.component';
import { addIcons } from "ionicons";
import { menu, home, cashOutline, apertureOutline, fileTrayFullOutline, folderOutline, location, list, repeatSharp, car, document as documentIcon, businessOutline, search, layersOutline, bus, compass, alert, star, peopleCircle, settings, ellipsisVerticalOutline, bagOutline, logOutOutline, earth, personCircleOutline, medalOutline, peopleOutline, serverOutline, podium } from "ionicons/icons";

@Component({
    selector: 'csi-menuLat',
    templateUrl: './menu-lat.component.html',
    styleUrls: ['./menu-lat.component.scss'],
    standalone: false,
})
export class MenuLatComponent
    extends MenuBaseComponent
    implements AfterViewInit {
    // Propio del menu de escritorio: panel de administrador y submenu de apps Ontrack.
    showAdminPanel: boolean = false;
    showOntrackMenu: boolean = false;

    public showQuantumCivarMenu: boolean[] = [];

    @ViewChild('submenuOntrackElem') submenuOntrackElem;
    @ViewChild('asideElem') asideElem;
    @ViewChild('scrollbarContainer') scrollbarContainer;
    isStatic: boolean = true;
    endedMenuInit: Boolean = false;
    ps: any = null;
    transitionEnd: string | null = null;
    openedFirstTime: boolean = false;

    @ViewChildren('quantumCivarElems') quantumCivarElems: QueryList<ElementRef>;
    addedEventListener: boolean = false;

    @ViewChild('homeSubmenuElem') homeSubmenuElem;
    HOME_SUBMENU_DEFAULT_HEIGHT = 86;

    constructor(
        router: Router,
        userProvider: UserProvider,
        plt: Platform,
        events: Events,
        dashboardsService: DashboardsService,
        storage: AppStorageProvider,
        private utilityService: UtilityFunctionService,
        capacitorService: CapacitorUtilsService,
        dataService: DataService,
    ) {
        super(
            router,
            events,
            dashboardsService,
            storage,
            capacitorService,
            dataService,
            userProvider,
            plt,
        );

        this.initializeApp();

        events.subscribe('menuLoad', () => {
            this.initializeApp();
        });
        addIcons({ menu, home, cashOutline, apertureOutline, fileTrayFullOutline, folderOutline, location, list, repeatSharp, car, document: documentIcon, businessOutline, search, layersOutline, bus, compass, alert, star, peopleCircle, settings, ellipsisVerticalOutline, bagOutline, logOutOutline, earth, personCircleOutline, medalOutline, peopleOutline, serverOutline, podium });
    }

    isTablet() {
        if (this.plt.is('tablet')) {
            if (this.plt.is('android') || this.plt.is('ios')) return true;
            else {
                return false;
            }
        } else {
            return false;
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.events.destroy('nav:active');
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();

        if (window.innerWidth < 991 || this.isTablet() || this.isIpad()) {
            this.asideElem.nativeElement.style.display = 'none';
        }
        this.isStatic = this.userProvider.isMenuStatic();
        if (!this.isStatic) {
            this.toggleStaticMenu(false);
        }
        this.transitionEnd = this.whichTransitionEnd();
        this.ps = new PerfectScrollbar(this.scrollbarContainer.nativeElement, {
            suppressScrollX: true,
        });
        if (this.transitionEnd !== null) {
            this.civarElems.changes.subscribe((elems) => {
                if (!this.addedEventListener) {
                    this.addedEventListener = true;
                    elems.forEach((el) => {
                        el.nativeElement.addEventListener(this.transitionEnd, () => {
                            this.ps.update();
                            this.ps.update();
                        });
                    });
                }
            });
        }

        setTimeout(() => {
            this.toggleShowMoreSubmenu();
        }, 1000);
    }

    whichTransitionEnd() {
        var el = document.createElement('div');

        var transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend',
        };

        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return transEndEventNames[name];
            }
        }

        return null;
    }

    initializeApp() {
        this.storage.get('userMenu').then((data: any) => {
            if (data) {
                this.applyMenuPreferences(data);
            }
        });
    }

    protected override reloadMenu(): void {
        this.initializeApp();
    }

    protected override onMenuDataProcessed(data: any): void {
        this.endedMenuInit = true;
        if (this.asideElem && this.asideElem.nativeElement && this.isStatic) {
            this.showQuantumMenu = true;
        }
        if (window.innerWidth < 991 || this.isTablet()) {
            if (this.plt.is('tablet') || this.isIpad()) {
                document.getElementById('menu-lat-container').style.display = 'none';
            }
        }
    }

    protected override afterMenuTransition(): void {
        if (this.transitionEnd === null) {
            setTimeout(() => {
                this.ps.update();
                this.ps.update();
            }, 500);
        }
    }

    mouseEnter() {
        if (!this.isStatic && !this.openedFirstTime) {
            this.openedFirstTime = true;
            this.showQuantumMenu = true;
            if (
                (this.submenuElem && this.submenuElem.nativeElement,
                    this.submenuElem.nativeElement.scrollHeight)
            ) {
                setTimeout(
                    () => {
                        this.submenuElem.nativeElement.style.maxHeight =
                            this.submenuElem.nativeElement.scrollHeight + 'px';
                    },
                    this.endedMenuInit ? 0 : 500,
                );
            }
        }
    }

    isIpad() {
        const ua = window.navigator.userAgent;
        if (ua.indexOf('iPad') > -1) {
            return true;
        }
        if (ua.indexOf('Macintosh') > -1) {
            try {
                document.createEvent('TouchEvent');
                return true;
            } catch (e) { }
        }
        return false;
    }

    toggleStaticMenu(publishEvent: boolean = true) {
        if (this.asideElem && this.asideElem.nativeElement) {
            // Posicionamiento del menu
            const added =
                this.asideElem.nativeElement.classList.toggle('static-menu');
            this.userProvider.setMenuStatic(added);
            this.isStatic = added;
            if (publishEvent) this.events.publish('staticmenu:toggle');
        }
    }

    toggleAppsMenu() {
        this.showOntrackMenu = !this.showOntrackMenu;
        this.submenuOntrackElem.nativeElement.style.maxHeight = this
            .showOntrackMenu
            ? this.submenuOntrackElem.nativeElement.scrollHeight + 'px'
            : '0px';

        this.afterMenuTransition();
    }

    goToAdminPanel() {
        this.sendNav.emit(61);
    }

    goToWebFrame() {
        this.sendNav.emit(100);
    }

    goToiFramePage() {
        const routeParams = {
            // Se genera un objeto con los parametros a transmitir a la siguiente route
            externalURL: 'https://ws.csigroup.com.mx/csi-quantumontrack/plan-viajes2', // URL del item a mostrar en el frame
            routeId: this.utilityService.randomNum(),
        };

        this.storage.put('Quantum:externalURL', routeParams);

        this.sendNav.emit(110);
    }

    /**
     * @name autoLoginARTUS
     * @description Metodo que hace un inicio de sesion en el sistem ARTUS
     */
    autoLoginARTUS(item, user, pass, dashboard) {
        if (user != null && pass != null) {
            var form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://aws.csigroup.com.mx/ARTUSG9/LoadStage.php';
            form.target = '_blank';

            form.method = 'POST';
            var element1 = document.createElement('input');
            var element2 = document.createElement('input');
            var element3 = document.createElement('input');
            var element4 = document.createElement('input');
            var element5 = document.createElement('input');

            element1.id = 'repository';
            element1.name = 'txtRepositorio';
            element1.value = 'BISunusProd';
            form.appendChild(element1);

            element2.id = 'username';
            element2.name = 'txtUser';
            element2.value = user;
            form.appendChild(element2);

            element3.id = 'password';
            element3.name = 'txtPassword';
            element3.value = pass;
            form.appendChild(element3);

            element4.name = 'txtNumEsc';
            element4.value = dashboard;
            form.appendChild(element4);

            element5.name = 'txtParametros';
            element5.value = 'TPParams';
            form.appendChild(element5);

            document.body.appendChild(form);

            form.submit();
        } else {
            if (
                this.plt.is('mobile') &&
                (this.plt.is('android') || this.plt.is('ios'))
            ) {
                this.capacitorService.goToLaunchBrowser(item.Desc_Pagina);
            } else {
                if (item.Bit_Frame) {
                    const routeParams = {
                        // Se genera un objeto con los parametros a transmitir a la siguiente route
                        externalURL: item.Desc_Pagina, // URL del item a mostrar en el frame
                        routeId: item.Id_Cnsc_Menu,
                    };
                    this.dataService.setData(routeParams.routeId, routeParams); // Con ayuda del provider DataService asignamos el objeto parametros a un iD, para de esta manera poder recibirlo en la siguiente ruta/pantalla
                    this.storage.put(routeParams.routeId, routeParams); // Con ayuda del provider StorageService asignamos el objeto parametros a un iD, para de esta manera poder obtenerlo desde el storage en caso de necesitarlo en la siguiente ruta/pantalla

                    this.router.navigate(['/quantum/civar/' + routeParams.routeId], {
                        replaceUrl: true,
                    });
                } else {
                    window.open(item.Desc_Pagina, '_blank');
                }
            }
        }
    }
}
